import React, {Component} from 'react';
import {connect} from 'react-redux';
import {FilePond, registerPlugin} from 'react-filepond';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import FilePondPluginFileRename from 'filepond-plugin-file-rename';
import {maxSizeAllFilesInMegaBytes} from '../../../../common/constants/ftr';
import Loader from '../../../../common/components/loader';
import './references.scss';
registerPlugin(FilePondPluginFileValidateType, FilePondPluginFileValidateSize, FilePondPluginFileRename);

export const MAXFILESIZE = `${maxSizeAllFilesInMegaBytes}MB`;

class References extends Component {
  componentDidMount() {
    const {handleChangeForm, images, files} = this.props;
    if (images.length && files.length !== images.length) {
      handleChangeForm('files', images);
    }
  }

  onDownloadFile = (position) => {
    const {rawImages} = this.props;
    const fileInBase64 = rawImages[position].file;
    const filename = rawImages[position].name;

    const pdfs = atob(fileInBase64);
    const len = pdfs.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = pdfs.charCodeAt(i);
    }
    this.saveDowloadedData(bytes.buffer, filename);
  };

  saveDowloadedData = (data, filename) => {
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.style = 'display: none';
    const blob = new Blob([data], {'type': 'octet/stream'});
    const url = window.URL.createObjectURL(blob);

    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
  };

  render() {
    const {files, handleChangeImages, stateTwc, rawImages, imagesLoading} = this.props;

    if (imagesLoading) {
      return (
        <div className='twc-loader-subcontracts'>
          <Loader />
        </div>
      );
    }

    if (stateTwc === '01') {
      return (
        <div className='warranty-container-references'>
          {rawImages ? (
            rawImages.map((file, idx) => (
              <p
                key={idx}
                style={{'textAlign': 'center'}}
                className='link'
                onClick={() => this.onDownloadFile(idx)}
              >
                {file.name}
              </p>
            ))
          ) : (
            <div className='warranty-container-references'>
              <h3>No se encuentran adjuntos disponibles</h3>
            </div>
          )}
        </div>
      );
    }

    return (
      <div className='warranty-container-references'>
        <FilePond
          maxFileSize={MAXFILESIZE}
          files={files}
          allowMultiple={true}
          onupdatefiles={(fileItems) => handleChangeImages(fileItems)}
          labelIdle='Arrastrar archivo o <span class="filepond--label-action">Navegador</span>'
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'images': state.warrantyImages.images,
    'rawImages': state.warrantyImages.rawImages,
    'imagesLoading': state.warrantyImages.loading,
  };
};

export default connect(mapStateToProps, {})(References);
